import { UnknownError } from 'src/errors';

export function normalizeError(rawErr: unknown): Error {
  return rawErr instanceof Error ? rawErr : new UnknownError(rawErr);
}
